import Header from "components/Headers/Header";
import React, { useEffect, useRef, useState } from "react";
import DOMPurify from "dompurify";
import {
  Button,
  Card,
  CardHeader,
  Col,
  Container,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  Row,
  Spinner,
} from "reactstrap";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { Editor } from "react-draft-wysiwyg";
import { EditorState } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { useDispatch, useSelector } from "react-redux";
import { AddBlogData } from "store/actions/blogActions";
import { getBlogData } from "store/actions/blogActions";
import { deleteBlog } from "store/actions/blogActions";
import moment from "moment";
import { updateBlog } from "store/actions/blogActions";
import { ContentState } from "draft-js";
import cross from "../assets/img/cross.svg";
import { toast } from "react-toastify";
import ReuseableTable from "components/Tables/ReuseableTable";
import draftToHtml from "draftjs-to-html";
import { convertToRaw } from "draft-js";
import htmlToDraft from "html-to-draftjs";

const AddBlogs = () => {
  const dispatch = useDispatch();
  let inputFile = useRef();
  const { blogs, lastDocument, hasMoreDocument } = useSelector(
    (state) => state.blog
  );
  const { user, uid } = useSelector((state) => state.auth);

  const [isLoading, setIsLoading] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [isTableLoading, setIsTableLoading] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
  const [editingBlogId, setEditingBlogId] = useState(null);
  const [modal, setModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [blogToDelete, setBlogToDelete] = useState(null);
  const [title, setTitle] = useState("");
  const [category, setCategory] = useState("");
  const [edit, setEdit] = useState(false);
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [image, setImage] = useState(null);
  const [oldImage, setOldImage] = useState(null);
  const toggle = () => setModal(!modal);
  const handleTitleChange = (e) => setTitle(e.target.value);
  const handleCategoryChange = (e) => setCategory(e.target.value);
  const onEditorStateChange = (editorState) => setEditorState(editorState);
  const openModalForEdit = (blog) => {
    setEdit(true);
    setTitle(blog.title);
    setCategory(blog.category);
    let descriptionText = "";
    if (
      typeof blog.description === "object" &&
      blog.description?.props?.dangerouslySetInnerHTML?.__html
    ) {
      descriptionText = blog.description.props.dangerouslySetInnerHTML.__html;
    } else {
      descriptionText = "<p></p>";
    }
    const blocksFromHTML = htmlToDraft(descriptionText);
    const { contentBlocks, entityMap } = blocksFromHTML;
    const contentState = ContentState.createFromBlockArray(
      contentBlocks,
      entityMap
    );
    const newEditorState = EditorState.createWithContent(contentState);
    setEditorState(newEditorState);
    setEditingBlogId(blog.id);
    let imageUrl = "";
    if (typeof blog.imageUrl === "object" && blog.imageUrl?.props?.src) {
      imageUrl = blog.imageUrl.props.src;
    }
    setImage(imageUrl || null);
    setOldImage(imageUrl || null);
    toggle();
  };

  const handleSubmit = () => {
    if (
      !title ||
      !category ||
      !image ||
      !editorState.getCurrentContent().hasText()
    ) {
      return toast.error("Please fill all the fields");
    }

    const rawContentState = convertToRaw(editorState.getCurrentContent());
    const descriptionHTML = draftToHtml(rawContentState);

    const blogData = {
      title,
      category,
      description: descriptionHTML,
      image,
      oldImage,
      athlete_id: user.athleteID,
      athlete_uid: user.id,
      editingBlogId,
    };

    if (editingBlogId) {
      setIsLoading(true);
      dispatch(
        updateBlog(blogData, () => {
          setIsLoading(false);
          setModal(false);
        })
      );
    } else {
      setIsLoading(true);
      dispatch(
        AddBlogData(blogData, () => {
          setIsLoading(false);
          setModal(false);
        })
      );
    }
  };

  const handleDelete = (obj) => {
    setIsDeleting(true);
    dispatch(
      deleteBlog(obj.id, obj.url, () => {
        setIsDeleting(false);
        setShowModal(false);
      })
    );
  };

  const loadMore = () => {
    setIsLoadingMore(true);
    dispatch(
      getBlogData(uid, lastDocument, () => {
        setIsLoadingMore(false);
      })
    );
  };

  const handleImageChange = (e) => {
    if (e.target.files[0]) {
      setImage(e.target.files[0]);
    }
  };

  const TABLE_DATA = {
    columns: ["TITLE", "DESCRIPTION", "CREATED AT", "Image"],
    keyMap: {
      TITLE: "title",
      DESCRIPTION: "description",
      "CREATED AT": "createdAt",
      Image: "imageUrl",
    },
    data:
      blogs.length > 0 ? (
        blogs?.map((blog) => {
          return {
            ...blog,
            title: blog.title,
            description: (
              <div
                className="d-inline-block text-wrap mt-3 w-100"
                style={{ maxWidth: "400px" }}
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(blog.description?.replace(
                    /<strong>/g,
                    '<strong style="font-weight: bold;">'
                  )),
                }}
              />
            ),
            createdAt: moment
              .unix(blog?.created_at?.seconds)
              .format("DD/MM/YYYY"),
            imageUrl: blog.imageUrl ? (
              <img src={blog.imageUrl} width={50} height={50} />
            ) : (
              "N/A"
            ),
          };
        })
      ) : (
        <tr>
          <td>N/A</td>
          <td>N/A</td>
          <td>N/A</td>
          <td>N/A</td>
          <td>N/A</td>
        </tr>
      ),
    renderActions: (row) => {
      return (
        <div className="d-flex flex-lg-row flex-column gap-2 align-items-center">
          {" "}
          <Button
            onClick={() => openModalForEdit(row)}
            size="sm"
            color="primary"
            className="mb-2 mb-lg-0"
          >
            Edit
          </Button>
          <Button
            onClick={() => {
              setBlogToDelete({
                id: row.id,
                url: row.imageUrl.props.src,
              });
              setShowModal(true);
            }}
            color="danger"
            size="sm"
          >
            Delete
          </Button>
        </div>
      );
    },
  };

  useEffect(() => {
    setIsTableLoading(true);
    dispatch(
      getBlogData(uid, "", () => {
        setIsTableLoading(false);
      })
    );
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <Header />
      <Container className="mt-2" fluid>
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0 justify-content-between d-flex flex-wrap align-items-center">
                <h1
                  className="mb-0"
                  style={{ fontSize: isSmallScreen ? "13px" : "26px" }}
                >
                  Blogs
                </h1>
                <Button
                  className="mt-2 bg-primary border-0 text-white"
                  onClick={() => {
                    setTitle("");
                    setCategory("");
                    setImage("");
                    setEditorState(EditorState.createEmpty());
                    setEditingBlogId(null);
                    toggle();
                  }}
                >
                  Create Blog
                </Button>
              </CardHeader>
              {isTableLoading ? (
                <div className="text-center my-4">
                  <Spinner color="primary"></Spinner>
                </div>
              ) : (
                <>
                  <ReuseableTable {...TABLE_DATA} />
                </>
              )}
            </Card>
          </div>
        </Row>
        {blogs?.length > 0 && blogs?.length > 4 && (
          <div className="text-center">
            <Button
              className="mt-2 bg-primary border-0  text-white"
              disabled={isLoadingMore || !hasMoreDocument}
              onClick={loadMore}
            >
              {isLoadingMore ? <Spinner size="sm" /> : "Load More"}
            </Button>
          </div>
        )}
      </Container>

      <Modal isOpen={showModal} centered>
        <ModalBody>
          <div className="text-center">
            <span className="mt-5" style={{ fontSize: 30 }}>
              Are you sure?
            </span>
            <br />
            <br />
            <span className="mt-5" style={{ fontSize: 16 }}>
              You want to delete.
            </span>
            <br />
            <br />
            <br />
            <Button color="primary" onClick={() => setShowModal(false)}>
              Cancel
            </Button>
            <Button
              color="danger"
              onClick={() => handleDelete(blogToDelete)}
              disabled={isDeleting}
            >
              {isDeleting ? <Spinner size="sm" /> : "Delete"}
            </Button>
          </div>
        </ModalBody>
      </Modal>

      <Modal isOpen={modal} toggle={toggle} size="xl">
        <ModalBody>
          <Container fluid>
            <Row>
              <div className="col">
                <Card className="shadow">
                  <CardHeader>
                    <Row>
                      <Col md={3}>
                        <Label className="mr-2 mb-1">Title</Label>
                        <Input
                          type="text"
                          value={title}
                          onChange={handleTitleChange}
                          required
                        />
                      </Col>
                      <Col md={3}>
                        <Label className="mr-2 mb-1">Category</Label>
                        <Input
                          type="select"
                          value={category}
                          onChange={handleCategoryChange}
                          required
                        >
                          <option value="">Select a category</option>
                          <option value="who">Who</option>
                          <option value="what">what</option>
                          <option value="when">When</option>
                          <option value="where">Where</option>
                          <option value="why">Why</option>
                          <option value="how">How</option>
                          <option value="miscellaneo">Miscellaneo</option>
                        </Input>
                      </Col>
                      <Col md={4}>
                        <Label className="mr-2 mb-3">Upload Image</Label>
                        <div className="d-flex flex-column">
                          <input
                            ref={inputFile}
                            type="file"
                            accept="image/png, image/gif, image/jpeg"
                            onChange={handleImageChange}
                          />
                        </div>
                      </Col>
                      <Col md={2} className="mt-2">
                        {image && (
                          <div className="position-relative">
                            <img
                              src={
                                !image.name
                                  ? image
                                  : URL?.createObjectURL(image)
                              }
                              alt="Selected"
                              width={50}
                              height={50}
                            />
                            <img
                              src={cross}
                              width={20}
                              alt=""
                              className="position-absolute"
                              style={{
                                top: "-23%",
                                left: "26%",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                setImage(null);
                                inputFile.current.value = "";
                              }}
                            />
                          </div>
                        )}
                      </Col>
                    </Row>
                  </CardHeader>
                  <div className="mx-4 my-2">
                    <Editor
                      className="border-0"
                      editorState={editorState}
                      toolbarClassName="toolbarClassName"
                      wrapperClassName="wrapperClassName"
                      editorClassName="editorClassName text-area"
                      onEditorStateChange={onEditorStateChange}
                      mention={{ separator: " ", trigger: "@" }}
                      toolbar={{
                        options: [
                          "inline",
                          "blockType",
                          "fontSize",
                          "fontFamily",
                          "list",
                          "textAlign",
                          "colorPicker",
                          "link",
                          "emoji",
                          "remove",
                          "history",
                        ],
                        inline: {
                          options: ["bold", "italic", "underline"],
                        },
                        blockType: {
                          options: ["Normal", "Blockquote", "Code"],
                        },
                        fontSize: {
                          options: [8, 10, 12, 14, 16, 18, 24, 30, 36, 48],
                        },
                        fontFamily: {
                          options: [
                            "Arial",
                            "Georgia",
                            "Impact",
                            "Tahoma",
                            "Times New Roman",
                            "Verdana",
                          ],
                        },
                        list: {
                          options: ["unordered", "ordered"],
                        },
                        textAlign: {
                          options: ["left", "center", "right"],
                        },
                        colorPicker: { disabled: false },
                        image: { disabled: true },
                        link: { options: ["link"] },
                        remove: { options: ["remove"] },
                        history: { options: ["undo", "redo"] },
                      }}
                      required
                    />
                  </div>
                </Card>
              </div>
            </Row>
          </Container>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleSubmit} disabled={isLoading}>
            {isLoading ? (
              <Spinner size="sm" />
            ) : editingBlogId ? (
              "Update"
            ) : (
              "Submit"
            )}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default AddBlogs;
